import React from 'react';
import {
    StyleSheet,
    Text,
} from 'react-native';
import colors from '../lib/colors';
import { responsive } from '../lib/responsive';

// i18n-ignore: technical-token -- registered product name, never translated.
const BRAND_TITLE = 'PAPERZILLA';

export default function HeaderBrandTitle() {
    return (
        <Text
            style={styles.title}
            numberOfLines={1}
            adjustsFontSizeToFit
            minimumFontScale={0.5}
            accessibilityRole="text"
            testID="header-brand-title"
            {...responsive('header-title')}
        >
            {BRAND_TITLE}
        </Text>
    );
}

const styles = StyleSheet.create({
    title: {
        color: colors.primaryGreenDark,
        fontWeight: '900',
        marginBottom: 0,
        maxWidth: '100%',
        minWidth: 0,
    },
});
